<template>
    <component
        :is="is"
        :data="data"
        :has-eager-image="hasEagerImage"
    />
</template>

<script lang="ts" setup>
import type { SquareBoxesFragment } from '@/graphql/api'
import { computed } from 'vue'
import { assertNever } from '@/helpers'
import DebugComponent from '@/components/cms/component/DebugComponent.vue'
import SquareImageBox from '@/components/cms/component/square-boxes/SquareImageBox.vue'
import SquareTextBox from '@/components/cms/component/square-boxes/SquareTextBox.vue'

const props = defineProps<{
    data: SquareBoxesFragment
    hasEagerImage?: boolean
}>()

const is = computed<any>(() => {
    const type = props.data.__typename

    switch (type) {
        case 'SquareImageBox':
            return SquareImageBox
        case 'SquareTextBox':
            return SquareTextBox
        default:
            return assertNever(type, DebugComponent)
    }
})
</script>
